export const DOCKER_CONTAINER_WEB_URL = 'http://localhost:5987';
